import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

const KEY = "revitalize.guest";

export const getGuest = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch {
    return null;
  }
};

export async function ensureGuest() {
  const g = getGuest();
  if (g?.guestId && g?.token) return g;
  const { data } = await api.post("/guests");
  localStorage.setItem(KEY, JSON.stringify(data));
  return data;
}

api.interceptors.request.use((cfg) => {
  const g = getGuest();
  if (g?.guestId) {
    cfg.headers["X-Guest-Id"] = g.guestId;
    cfg.headers["X-Guest-Token"] = g.token;
  }
  return cfg;
});

export const assetUrl = (u) => (u ? (u.startsWith("http") ? u : `${BACKEND}${u}`) : null);

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};

export const pendingUploads = new Map();

export const MSG = {
  type: "Only JPEG, PNG, WebP or HEIC photos are supported.",
  size: "Photos must be under 20 MB.",
  count: "A property can have up to 20 photos.",
  zillow: "That doesn't look like a Zillow listing link.",
  zillowNoPhotos: "Zillow doesn't allow automatic photo import. Upload your listing photos to continue.",
  limit: "You've reached today's free limit. Come back tomorrow.",
  walkLabel: "Conceptual walkthrough — not a measured 3D reconstruction",
};

const EXT = ["jpg", "jpeg", "png", "webp", "heic", "heif"];
const MIME = ["image/jpeg", "image/png", "image/webp", "image/heic", "image/heif"];

export function validateFile(file) {
  const ext = (file.name.split(".").pop() || "").toLowerCase();
  if (!EXT.includes(ext) && !MIME.includes((file.type || "").toLowerCase())) return MSG.type;
  if (file.size > 20 * 1024 * 1024) return MSG.size;
  return null;
}

export const ACCEPT = "image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif,.jpg,.jpeg,.png,.webp";
